module.exports = __webpack_public_path__ + "img/fun3.afa76750.png";